export * from './AwardMedalIcon';
export * from './AwardMedalIcon16Light';
export * from './AwardMedalIcon16Regular';
export * from './AwardMedalIcon16Solid';
export * from './AwardMedalIcon20Light';
export * from './AwardMedalIcon20Regular';
export * from './AwardMedalIcon20Solid';
export * from './AwardMedalIcon24Regular';
export * from './AwardMedalIcon24Solid';
export * from './AwardMedalIcon32Regular';
export * from './AwardMedalIcon64Regular';
